export default "__VITE_ASSET__98acd802__"